<template>
	<div
		:class="classes"
		class="article-cover-image"
		role="img"
		:aria-label="ariaLabel"
		data-test="article-cover-image-element"
		:style="coverImageStyle"
	></div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { SanityAsset } from 'types/sanity';
import { useSanityImage } from '@utils/composables/use-sanity-image';

interface Props {
	coverImage: SanityAsset;
	classes?: string;
}

const props = defineProps<Props>();

const sanityImage = useSanityImage(props.coverImage.url);
const fallbackImage = `${appCloudfrontPath}/images/marketing-site/placeholder.png`;

const coverImageStyle = computed(() => ({
	backgroundImage: `url(${sanityImage.value ?? fallbackImage})`
}));

const ariaLabel = computed(() => props.coverImage?.altText ?? 'article cover image');
</script>
